import { defineMessages } from 'react-intl'

export default defineMessages({
  claimsHeader: {
    id: 'app.claims.header',
    defaultMessage: 'Report a claim',
  },
  claimsPreview: {
    id: 'app.claims.preview',
    defaultMessage: 'Preview',
  },
  claimsIncomplete: {
    id: 'app.claims.inclomplete',
    defaultMessage: 'Incomplete',
  },
  claimsNoDriver: {
    id: 'app.claims.noDriver',
    defaultMessage: 'No Driver',
  },
  claimsNoOfficer: {
    id: 'app.claims.noOfficer',
    defaultMessage: 'No Police Officer',
  },
  claimsNoPassenger: {
    id: 'app.claims.noPassenger',
    defaultMessage: 'No Passenger',
  },
  claimsNoWitness: {
    id: 'app.claims.noWitness',
    defaultMessage: 'No Witness',
  },
  claimsVehicle: {
    id: 'app.claims.vehicle',
    defaultMessage: 'Vehicle',
  },
  claimsVehicles: {
    id: 'app.claims.vehicles',
    defaultMessage: 'Vehicles',
  },
  claimsVehicleRequired: {
    id: 'app.claims.vehicle.required',
    defaultMessage: 'Vehicle is required!',
  },
  claimsTimeAndDate: {
    id: 'app.claims.timeAndDate',
    defaultMessage: 'Time and Date',
  },
  claimsLocation: {
    id: 'app.claims.location',
    defaultMessage: 'Location',
  },
  claimsLocationSubtitle: {
    id: 'app.claims.locationSutitle',
    defaultMessage: 'Near this location',
  },
  claimsWeather: {
    id: 'app.claims.weather',
    defaultMessage: 'Weather',
  },
  claimsDriver: {
    id: 'app.claims.driver',
    defaultMessage: 'Driver',
  },
  claimsWhatHappened: {
    id: 'app.claims.whatHappend',
    defaultMessage: 'What happened',
  },
  claimsPictures: {
    id: 'app.claims.pictures',
    defaultMessage: 'Pictures',
  },
  claimsNumberOfPictures: {
    id: 'app.claims.numberOfPictures',
    defaultMessage: '{numberOfPictures, plural, one {# picture added} other {# pictures added}}',
  },
  claimsOtherVehicleAndDriver: {
    id: 'app.claims.otherVehicleAndDriver',
    defaultMessage: 'Other Vehicle And Driver',
  },
  claimsInvestigatingOfficer: {
    id: 'app.claims.investigatingOfficer',
    defaultMessage: 'Investigating Officer',
  },
  claimsPassenger: {
    id: 'app.claims.passenger',
    defaultMessage: 'Passenger',
  },
  claimsWitness: {
    id: 'app.claims.witness',
    defaultMessage: 'Witness',
  },
  claimsNotes: {
    id: 'app.claims.notes',
    defaultMessage: 'Notes',
  },
  claimsNotificationThankYou: {
    id: 'app.claims.notification.thankYou',
    defaultMessage: 'Thank you',
  },
  claimsNotificationClaimSubmitted: {
    id: 'app.claims.notification.claimSubmitted',
    defaultMessage:
      'The Claim Report has been sent, someone will get back to you as soon as possible.',
  },
  claimsNotificationSomethinWentWrong: {
    id: 'app.claims.notification.somethingWentWrong',
    defaultMessage: 'Something went wrong',
  },
  claimsName: {
    id: 'app.claims.name',
    defaultMessage: 'Name',
  },
  claimsDescription: {
    id: 'app.claims.description',
    defaultMessage: 'Description',
  },
  claimsDescriptionDamage: {
    id: 'app.claims.descriptionDamage',
    defaultMessage: 'Describe your damage',
  },
  claimsFillOutTheForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
})
